(function () {
  function getLineHeight(element) {
    var style = window.getComputedStyle(element);
    var lineHeight = parseFloat(style.lineHeight);

    if (!lineHeight || Number.isNaN(lineHeight)) {
      var fontSize = parseFloat(style.fontSize) || 16;
      lineHeight = fontSize * 1.65;
    }

    return lineHeight;
  }

  function initPopularSearches(root) {
    if (!root || root.dataset.popularSearchesReady === 'true') return;
    root.dataset.popularSearchesReady = 'true';

    var list = root.querySelector('[data-popular-searches-list]');
    var toggle = root.querySelector('[data-popular-searches-toggle]');
    if (!list || !toggle) return;

    var collapsedLines = parseInt(root.getAttribute('data-collapsed-lines'), 10) || 2;
    var readMoreLabel = root.getAttribute('data-read-more') || 'Read More';
    var readLessLabel = root.getAttribute('data-read-less') || 'Read Less';
    var keywords = list.querySelector('.footer-popular-searches__keywords');
    var collapsedHeight = 0;
    var expandedHeight = 0;

    function measureHeights() {
      list.style.maxHeight = 'none';
      expandedHeight = list.scrollHeight;
      collapsedHeight = Math.ceil(getLineHeight(keywords || list) * collapsedLines);
    }

    function setCollapsed(animate) {
      list.style.maxHeight = collapsedHeight + 'px';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = readMoreLabel;

      if (animate === false) {
        list.style.transition = 'none';
        window.requestAnimationFrame(function () {
          list.style.transition = '';
        });
      }
    }

    function setExpanded() {
      list.style.maxHeight = expandedHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = readLessLabel;
    }

    function refresh() {
      measureHeights();

      if (expandedHeight <= collapsedHeight + 2) {
        toggle.hidden = true;
        list.style.maxHeight = 'none';
        return;
      }

      toggle.hidden = false;

      if (toggle.getAttribute('aria-expanded') === 'true') {
        setExpanded();
      } else {
        setCollapsed(false);
      }
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        setCollapsed(true);
      } else {
        measureHeights();
        setExpanded();
      }
    });

    refresh();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });
  }

  function boot() {
    document.querySelectorAll('[data-footer-popular-searches]').forEach(initPopularSearches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-footer-popular-searches]').forEach(function (root) {
      delete root.dataset.popularSearchesReady;
    });
    boot();
  });
})();
